(function () {
  function initStores(root) {
    if (!root || root.dataset.wxStoresReady === '1') return;
    root.dataset.wxStoresReady = '1';

    var track = root.querySelector('[data-wx-stores-track]');
    var fill = root.querySelector('[data-wx-stores-progress]');
    var prev = root.querySelector('[data-wx-stores-prev]');
    var next = root.querySelector('[data-wx-stores-next]');
    if (!track) return;

    function updateProgress() {
      if (!fill) return;
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? (track.scrollLeft / max) * 100 : 100;
      fill.style.width = Math.max(8, Math.min(100, pct || 8)) + '%';
    }

    function scrollByCard(dir) {
      var card = track.querySelector('.wx-contact__store');
      var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  function boot() {
    document.querySelectorAll('[data-wx-stores]').forEach(initStores);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector('[data-wx-stores]');
    if (root) {
      delete root.dataset.wxStoresReady;
      initStores(root);
    }
  });
})();
